export const POSITION_OPTIONS = [
    { value: "Goalkeeper", short: "GK" },
    { value: "Left Back", short: "LB" },
    { value: "Centre Back", short: "CB" },
    { value: "Right Back", short: "RB" },
    { value: "Defensive Midfield", short: "CDM" },
    { value: "Central Midfield", short: "CM" },
    { value: "Attacking Midfield", short: "AM" },
    { value: "Right Wing", short: "RW" },
    { value: "Left Wing", short: "LW" },
    { value: "Center Forward", short: "CF" },
];